//Nav Menu Bar
import { Logo } from '@digitools/honest-react';
import { Nav } from '@digitools/honest-ui';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useExperience from '../../hooks/useExperience';
import { Experience } from 'src/types/Experience';
import { getHomeUrl } from 'src/utils/NavigationUtils';
import useAuthentication from '../../hooks/useAuthentication';
import { getEnvVariable } from 'src/utils/envUtils';
import useCustomerConfig from 'src/hooks/useCustomerConfig';
import useTealium from '../../hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import { useNavItems } from './buildNavItems';
import './NavMenuBar.css';
/**
 * NavMenuBar
 *
 * Renders the primary nav bar (logo + home + configurable nav-menu links) via
 * honest-ui's <Nav>. Data comes from the nav-menu API (useCustomerConfig);
 * per-link routing/SSO/analytics decisions are resolved by resolveNavItem
 * (shared with the footer) via buildNavItems.
 */
const NavMenuBar = () => {
    const { experience, language } = useExperience();
    const { user, isAuthenticated } = useAuthentication();
    const { loadingNavMenu } = useCustomerConfig();
    const { trackEvent } = useTealium();
    const location = useLocation();
    useEffect(() => {
        //FIXME: find a better way to do this - this broke lots of tests due to lack of null check (now fixed) Has to be a cleaner way to do this
        setInterval(() => {
            const sessionIframe = document.getElementById('ssoKeepAliveIframe');
            const keepAliveURL = getEnvVariable('lfgAuthUrl') +
                '/authorize?response_type=id_token token&prompt=none&client_id=' +
                getEnvVariable('lfgAuthClientId') +
                '&&redirect_uri=' +
                getEnvVariable('keepAliveGifUrl') +
                '&nonce=' +
                Math.random();
            if (sessionIframe) {
                //FIXME: there is no src value on an HTML element. not sure if/when/why/how this 'src' is being used
                //@ts-ignore
                sessionIframe.src = keepAliveURL;
            }
        }, 300000);
    }, [experience]);
    const trackPageEvent = (label) => {
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: label,
            event_type: TEALIUM_EVENT.EVENT_TYPE.HOME_PAGE,
            event_version: TEALIUM_EVENT.EVENT_TYPE.HEADER,
        });
    };
    const onNavigate = (navLink) => trackPageEvent(navLink.analyticsLabel ?? navLink.label.english);
    const navItems = useNavItems(onNavigate);
    const redirectLink = getHomeUrl(experience, user?.roles);
    // Nav (logo + bar) always renders so its height is reserved while the nav-menu API loads;
    // only the items wait on the response, which avoids a vertical layout jump.
    const showNavItems = !loadingNavMenu && experience !== Experience.PUBLIC && location?.pathname !== '/customer-search';
    return (<>
      {/* Nav doesn't forward arbitrary props (e.g. data-testid/data-public) to its root DOM node,
            so they're placed on this wrapper instead. */}
      <div data-testid='mlp-nav' data-public={experience === Experience.PUBLIC} data-loading={loadingNavMenu || undefined}>
        <Nav logo={<Logo alt='Lincoln Financial' style={{ width: '143px', height: '49px' }}/>} logoHref={redirectLink} logoLabel='Lincoln Financial home' isLoggedIn={isAuthenticated} language={language}>
          {loadingNavMenu && (
        // Invisible stand-in so the row is as tall as a populated nav (items are taller than the logo),
        // preventing a small vertical shift when the real items arrive.
        <Nav.Item label={'\u00a0'} href='#'/>)}
          {showNavItems &&
            navItems.map(item => item.groups ? (<Nav.Item key={item.id} label={item.label}>
                  {item.groups.map(group => (<Nav.Group key={group.id} heading={group.heading}>
                      {group.links.map((link, index) => (<Nav.Link key={index} href={link.href} linkType={link.linkType} onClick={link.onClick} icon={link.icon}>
                          {link.label}
                        </Nav.Link>))}
                    </Nav.Group>))}
                </Nav.Item>) : (<Nav.Item key={item.id} label={item.label} href={item.href} linkType={item.linkType} onClick={item.onClick} icon={item.icon}/>))}
        </Nav>
      </div>
    </>);
};
export default NavMenuBar;
